<template>
	<section>
		<b-modal
			ref="modalLogin"
			ok-title="Acceder"
			hide-header
			hide-footer
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-backdrop
		>
			<b-overlay :show="loading" no-wrap></b-overlay>
			<div class="text-center">
				<img :src="logo" style="max-width: 300px" />
			</div>
			<hr />
			<b-form ref="loginForm" @submit="onSubmit">
				<div class="row justify-content-md-center">
					<div class="col-sm-12 col-md-8">
						<b-form-group label="Correo electronico">
							<b-form-input
								v-model="form.email"
								type="email"
								required
							></b-form-input>
						</b-form-group>
						<b-form-group label="Contraseña">
							<b-form-input
								v-model="form.password"
								type="password"
								required
							></b-form-input>
						</b-form-group>
					</div>
				</div>
				<div class="text-center">
					<p class="text-danger" v-if="error">
						{{ error_message }}
					</p>
					<a href="/reset-passwd" @click="$root.setRouteEvt"
						>¿Olvidaste tu contraseña?</a
					>
				</div>
				<hr />
				<div class="text-right">
					<b-button variant="primary" type="submit">Acceder</b-button>
				</div>
			</b-form>
		</b-modal>
	</section>
</template>

<script>
import api from "../../../api.js";
import logo from "../../../assets/logo-sc-negro.png";

export default {
	components: {},
	data() {
		return {
			logo,
			form: {
				email: "",
				password: ""
			},
			error_message: "Usuario o contraseña incorrectos",
			error: false,
			loading: false
		};
	},
	methods: {
		isEmail(valor) {
			// eslint-disable-next-line
			var cor = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; /* eslint-disable-line */
			if (cor.test(valor)) {
				return true;
			} else {
				return false;
			}
		},
		onSubmit(evt) {
			//validate
			evt.preventDefault();
			//validate input email
			if (!this.isEmail(this.form.email)) {
				this.error = true;
				this.error_message = "El correo electrónico no es correcto";
				return;
			}
			//validate password blanks
			this.form.password = this.form.password.trim();

			this.error = false;
			this.loading = true;
			api(this)
				.post("/auth/login", this.form)
				.then(res => {
					this.$root.store.setUserToken(res.data.access_token);
					api(this)
						.post("/auth/me")
						.then(res2 => {
							if (!res2.data.permissions) {
								this.$root.store.clearUser();
								this.error = true;
								this.error_message = "Este usuario no tiene permisos";
							} else {
								this.$root.store.setUserData(res2.data);
								if(this.$hasModule('reservation')){
									this.$root.store.setRoute("/");
								}else{
									this.$root.store.setRoute("/home");
								}
							}
						});
				})
				.catch(() => {
					this.loading = false;
					this.error = true;
					this.error_message = "Usuario o contraseña incorrectos";
				})
				.then(() => {
					this.loading = false;
				});
		}
	},
	mounted() {
		//valiamos si hay un usuario logueado para ya no volver a mostrar el formulario de inicio de sesion
		if (this.user && window.location.pathname === "/login") {
			this.$root.store.setRoute("/");
			return;
		}

		this.$refs["modalLogin"].show();
	},
	computed: {
		//recuperamoslos datos del usuario logueado
		user() {
			return this.$root.store.state.currentUser;
		}
	}
};
</script>

<style></style>
